export module WCCSliderConfig {
    export const spaceBetweenPages = 80;
}